import { render, staticRenderFns } from "./short-term-quiz.vue?vue&type=template&id=4b706948&scoped=true"
import script from "./short-term-quiz.vue?vue&type=script&lang=js"
export * from "./short-term-quiz.vue?vue&type=script&lang=js"
import style0 from "./short-term-quiz.vue?vue&type=style&index=0&id=4b706948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b706948",
  null
  
)

export default component.exports